/**
 * The planner's stage-destination payload for a POI, used when it becomes a
 * day's stage end or the trail start. `itemId` is `<type>:<id>` so a POI keeps
 * one identity whichever map layer it was opened from.
 */
export interface PoiStageDestinationInput {
  poiType?: string | null;
  type?: string | null;
  poiId?: string | number | null;
  id?: string | number | null;
  name?: string | null;
  lngLat: { lng: number; lat: number };
}

export interface PoiStageDestination {
  itemType: 'poi';
  itemId: string;
  name: string;
  poiType: string;
  coordinates: [number, number];
}

export function poiStageDestination(input: PoiStageDestinationInput): PoiStageDestination {
  const type = input.type || 'other';
  return {
    itemType: 'poi',
    itemId: `${input.poiType || type}:${input.poiId ?? input.id}`,
    name: input.name || type,
    poiType: type,
    coordinates: [input.lngLat.lng, input.lngLat.lat],
  };
}
